export default __webpack_public_path__ + "static/media/def.d01780d3.png";